var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwinkle106(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "189.81891035013575 150.1553672331166 31.00663599542122 31.394632766883404",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M205.26,177.55c-2.82-.11-5.3-1.02-7.47-2.57-3.13-2.23-4.54-5.39-3.76-9.19,1.11-5.43,4.39-9.16,9.58-11.12,2.17-.82,4.31-.73,6.24.78.46.36.9.82,1.42,1,5.06,1.75,5.3,6.08,5.55,10.37.05.86-.25,1.73-.42,2.6-.63,3.29-2.53,5.6-5.65,6.74-1.76.64-3.65.94-5.49,1.39ZM210.64,161.08c-1.79-1.05-3.32-1.3-4.89-.53-2.59,1.27-4.46,3.22-5.58,5.91-.64,1.55-.26,2.94.82,4.03,2.42,2.44,7.72,2.16,9.26-1.58,1.04-2.54,1.17-5.06.4-7.82Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwinkle106);
export default __webpack_public_path__ + "static/media/twinkle-1-06.a75911cec5a213d321c12a19f56ddbc7.svg";
export { ForwardRef as ReactComponent };